import React, { useState, useEffect } from 'react';

function HistoryTable({ 
  columns = [], 
  data = [], 
  currentPage, 
  setCurrentPage, 
  rowsPerPage = 10,
  loading = false 
}) {
  const [showLoading, setShowLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);
  
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    // Start showing loading when loading prop is true
    if (loading) {
      setShowLoading(true);
      setShowContent(false);
      
      // Show content after 3 seconds
      const timer = setTimeout(() => {
        setShowLoading(false);
        setShowContent(true);
      }, 3000);
      
      return () => clearTimeout(timer);
    } else if (!loading && data.length > 0) {
      // If loading is done and we have data, show content
      setShowLoading(false);
      setShowContent(true);
    } else if (!loading && data.length === 0) {
      // If loading is done but no data, show "No data found"
      setShowLoading(false);
      setShowContent(true);
    }
  }, [loading, data.length]);

  return (
    <div className="table-container">
      <table className="member-table">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {showLoading ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                Loading data...
              </td>
            </tr>
          ) : showContent && currentRows.length > 0 ? (
            currentRows.map((row, i) => (
              <tr key={i}>
                {columns.map((col, j) => (
                  <td key={j}>{row[col.field]}</td>
                ))}
              </tr>
            ))
          ) : showContent ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data found
              </td>
            </tr>
          ) : (
            // Initial state - show nothing or loading
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                Loading...
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination - Only show when we have content, not loading, and there are pages */}
      {showContent && !showLoading && totalPages > 0 && (
        <div className="transaction-pagination">
          <button
            className="page-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          >
            &lt;
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            className="page-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          >
            &gt;
          </button>
        </div>
      )}
    </div>
  );
}

export default HistoryTable;